import { NavLink } from "reactstrap";
import { Quickoption } from "../../../Constant";
import { CUSTOMIZER_DATA } from "../../../Data/Customizer";
import { NavcustomizerType } from "../../../Type/CustomizerType";

export const NavCustomizer = ({ callbackNav, selected }: NavcustomizerType) => {
  return (
    <div className="nav flex-column nac-pills">
      <NavLink id="c-pills-home-tab" href="#c-pills-home" className={selected === "sidebar-type" ? "active" : ""} onClick={() => callbackNav("sidebar-type", true)}>
        <div className="settings"><i className="icon-paint-bucket"></i></div>
        <span>{Quickoption}</span>
      </NavLink>
      {CUSTOMIZER_DATA &&
        CUSTOMIZER_DATA.map((item, index) => (
          <NavLink key={index} href={item.path} target="_blank" rel="noopener noreferrer">
            <div><i className={item.icon}></i></div>
            <span>{item.name}</span>
          </NavLink>
        ))}
    </div>
  );
};
